// extracted by mini-css-extract-plugin
export default {"wrapper":"Shortcuts_wrapper__JjM89","keyCell":"Shortcuts_keyCell__nWnSB","keyIcon":"Shortcuts_keyIcon__0e8CO"};